import { render, staticRenderFns } from "./UserPoints.vue?vue&type=template&id=1d50a25c&scoped=true"
import script from "./UserPoints.vue?vue&type=script&lang=js"
export * from "./UserPoints.vue?vue&type=script&lang=js"
import style0 from "./UserPoints.vue?vue&type=style&index=0&id=1d50a25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d50a25c",
  null
  
)

export default component.exports